<template>
  <div id="nav" v-if="flag.roleChecked">
    <AdminSideMenu />
    <div :class="isAdminPage ? 'admin-wrapper' : ''">
      <div><router-view /></div>
    </div>
    <LoadingsModal />
    <ContentsModal />
    <MessagesModal />
    <div v-if="showFooter" class="footer-wrapper">
      <Footer />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  AdminSideMenu,
  Footer,
} from '@/components/layouts';
// import Spacer from '@/components/Spacer';
import { ContentsModal, MessagesModal, LoadingsModal } from '@/components/modal';

export default {
  name: 'app',
  components: {
    // Spacer,
    ContentsModal,
    MessagesModal,
    LoadingsModal,
    Footer,
    AdminSideMenu,
  },
  data() {
    return {
      flag: {
        roleChecked: false,
        isAdminPage: false,
        showFooter: false,
        isnotRequireLogin: false,
      },
    };
  },
  computed: {
    ...mapState(['page', 'user']),
    isAdminPage() {
      return this.$route.path.includes('admin');
    },
    showFooter() {
      return this.$route.path === '/';
    },
    isModal() {
      const contents = this.$store.state.modal.contents.modalName !== '';
      const loadings = this.$store.state.modal.loadings.modalName !== '';
      const messages = this.$store.state.modal.messages.modalName !== '';
      return contents || loadings || messages;
    },
  },
  mounted() {
    // ズームやダブルクリック、ホイール操作を無効化
    document.addEventListener('gesturestart', (e) => {
      e.preventDefault();
    });

    document.addEventListener('dblclick', (e) => {
      e.preventDefault();
    });

    document.addEventListener('wheel', (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    }, { passive: false });
  },
  created() {
    // ログインチェック
    this.$store.dispatch('user/login/check');
    // masterデータの取得
    this.$store.dispatch('helper/getMaster');
    this.$store.commit('cart/setCart');
    // クエリパラメータを取得
    const queryParams = new URLSearchParams(window.location.search);
    const source = queryParams.get('utm_source');

    // ローカルストレージに保存
    if (source) {
      localStorage.setItem('sourceValue', source);
    }
  },
  watch: {
    user: {
      handler() {
        this.checkRole();
      },
      deep: true,
    },
    $route() {
      this.checkRole();
    },
  },
  methods: {
    setMetas: (route) => {
      const meta = {};
      // 個別設定がない場合のデフォルト設定
      const defaults = {
        title: 'スマオーダー',
        description: '飲食店内注文システム',
      };

      meta.name = route.name;
      meta.title = route.meta.title ? `${route.meta.title} | ${defaults.title}` : defaults.title;
      meta.description = route.meta.description || defaults.description;

      // meta sets
      document.title = meta.title;
      document.querySelector("meta[name='description']").setAttribute('content', meta.description);
    },
    checkRole() {
      this.flag.roleChecked = false;
      if (!this.user.login.isChecked) return;

      const restrictedPaths = ['users', 'admin-users'];
      const isRestrictedPath = restrictedPaths.some((path) => this.$route.path.includes(path));

      if (isRestrictedPath && this.user.role?.role < 11) {
        alert('アクセス権限がありません。トップページへリダイレクトします。');
        this.$router.push({ path: '/' });
        return;
      }

      this.flag.roleChecked = true;
    },
  },
};
</script>


<style lang="scss">
/**
 * ここでimportしているscssは
 * 全てのページに適用されます
 */
@import './assets/scss/_variables.scss';
@import './assets/scss/_keyframes.scss';
@import './assets/scss/fonts.scss';
@import './assets/scss/modal.scss';
@import './assets/scss/style.scss';
</style>
<style lang="scss" scoped>
$sideMenuHeight: 100px;
.admin-wrapper {
  min-height: 100vh;
  padding-top: $sideMenuHeight;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

</style>
